module.exports = __webpack_public_path__ + "static/media/VattenfallHall-Medium.fc7f0ea2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/VattenfallHallMedium/VattenfallHall-Medium.woff2
// module id = 193
// module chunks = 0